import {breakpoints} from 'Common/constants/Breakpoints';
import Theme from 'Common/constants/Theme';
import Typography from 'Common/constants/Typography';
import styled from 'styled-components';

export const PaginationTextBase = styled.div`
  font-family: ${Theme.font.primary};
  font-style: normal;
  font-weight: ${Typography.weight.normal400};
  font-size: ${Typography.size.size14};
  line-height: 24px;
  margin-right: 8px;

  @media ${breakpoints.sm} {
    font-size: ${Typography.size.size16};
  }
`;
